import { render } from "./tab-1.vue?vue&type=template&id=42b20c0b&scoped=true"
import script from "./tab-1.vue?vue&type=script&lang=js"
export * from "./tab-1.vue?vue&type=script&lang=js"

import "./tab-1.vue?vue&type=style&index=0&id=42b20c0b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42b20c0b"

export default script